(ns frontend.view.grid.exit-opportunities-grid.columns)


(def not-available
  #{:common/attachments
    :role/guest-buy-side
    :exit-opportunity/ratings})

;;default set of selected columns
(def ordered-default-columns
  [:exit-opportunity/name
   [:exit-opportunity/buyer :investor/legal-entity]
   :exit-opportunity/stage
   :exit-opportunity/status
   :exit-opportunity/cur-expected-EV])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:exit-opportunity/name})

(def my-exit-opportunities-ordered-columns
  [:exit-opportunity/name
   [:exit-opportunity/buyer :investor/legal-entity]
   :exit-opportunity/stage
   :exit-opportunity/status
   :exit-opportunity/cur-expected-EV])

(def my-exit-opportunities-columns
  (set my-exit-opportunities-ordered-columns))

(def lost-exit-opportunities-ordered-columns
  [:exit-opportunity/name
   [:exit-opportunity/buyer :investor/legal-entity]
   :exit-opportunity/stage
   :exit-opportunity/lost-reason
   :exit-opportunity/lost-comment
   :exit-opportunity/lost-on
   :exit-opportunity/owner])

(def lost-exit-opportunities-columns
  (set lost-exit-opportunities-ordered-columns))

(def exit-opportunities-on-hold-ordered-columns
  [:exit-opportunity/name
   [:exit-opportunity/buyer :investor/legal-entity]
   :exit-opportunity/stage
   :exit-opportunity/on-hold-comment
   :exit-opportunity/put-on-hold-on
   :exit-opportunity/on-hold-until
   :exit-opportunity/cur-expected-EV])

(def exit-opportunities-on-hold-columns
  (set exit-opportunities-on-hold-ordered-columns))
